import React from "react";

import { useTranslation } from "next-i18next";

import RecipePanPreview from "@/components/blocks/global/recipe-pan-preview/RecipePanPreview";
import { Box, Typography } from "@mui/material";

export const FavouriteFolder = ({ folder }: any): JSX.Element => {
  const { t } = useTranslation("searchpage");
  const { name, pk, count, recipes } = folder;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: 163,
        overflow: "hidden",
        borderRadius: 2,
        boxShadow: 1
      }}>
      <Box
        sx={{
          flex: 1,
          width: "100%",
          display: "flex",
          gap: 0.25,
          justifyContent: "center",
          alignItems: "center",
          "&>div": {
            p: 0.5,
            display: "flex",
            justifyContent: "start",
            alignItems: "center"
          }
        }}>
        <Box
          flex={1}
          sx={{ overflow: "hidden", height: "100%", bgcolor: "gray.main" }}>
          {recipes?.[0] && (
            <RecipePanPreview recipe={recipes[0].content_object} />
          )}
        </Box>
        <Box
          flex={1}
          sx={{ overflow: "hidden", height: "100%", bgcolor: "gray.main" }}>
          {recipes?.[1] && (
            <RecipePanPreview recipe={recipes[1].content_object} />
          )}
        </Box>
        <Box
          flex={1}
          sx={{ overflow: "hidden", height: "100%", bgcolor: "gray.main" }}>
          {recipes?.[2] && (
            <RecipePanPreview recipe={recipes[2].content_object} />
          )}
        </Box>
      </Box>
      <Box
        display={"flex"}
        width={"100%"}
        justifyContent={"space-between"}
        alignItems={"center"}
        px={1.25}
        py={0.5}>
        <Typography>{name}</Typography>
        <Typography textTransform={"lowercase"} color={"primary.light"}>
          {count} {t("recipes")}
        </Typography>
      </Box>
    </Box>
  );
};
